import { Component, inject, OnInit, OnDestroy } from '@angular/core';
import { ToastModule } from 'primeng/toast';
import { MessageService } from 'primeng/api';
import { ToastService } from '../../services/toast.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-toast',
  standalone: true,
  imports: [ToastModule],
  providers: [MessageService],
  // Fora da pilha de camadas: com `autoZIndex`, o aviso visível virava a camada do topo e o Esc do
  // diálogo aberto por baixo (que só fecha quando é o topo) parava de funcionar por 3 segundos.
  // A camada fixa fica no styles.scss, acima de qualquer diálogo.
  template:
    '<p-toast position="top-right" styleClass="liv-toast" [life]="3000" [autoZIndex]="false"></p-toast>',
})
export class ToastComponent implements OnInit, OnDestroy {
  private readonly messageService = inject(MessageService);
  private readonly toastService = inject(ToastService);
  private subscription?: Subscription;

  ngOnInit(): void {
    this.subscription = this.toastService.message$.subscribe((message) => {
      this.messageService.add({
        severity: message.severity,
        summary: message.summary,
        detail: message.detail,
        life: message.life,
      });
    });
  }

  ngOnDestroy(): void {
    this.subscription?.unsubscribe();
  }
}
